import { ReactComponent as CartIcon } from "assets/cart.svg";
import { IconButton } from "components/UI/atoms";
import { useCartContext } from "context/cart-context";
import { calculateTimerColor } from "utils/timer";
import "./index.scss";

export const MenuCartIcon = ({ timeIsUp, length, seconds }) => {
  const { toggleCartOpening } = useCartContext();

  return (
    <>
      <IconButton
        IconComponent={CartIcon}
        onClick={toggleCartOpening}
        data-testid="cart-icon-toggle"
      />
      {length > 0 && (
        <span
          className="item-count"
          data-testid="item-count"
          style={{
            backgroundColor: calculateTimerColor(seconds)
          }}
        >
          {(!timeIsUp && length) || "!"}
        </span>
      )}
    </>
  );
};
